import { useRef, useState, useImperativeHandle} from 'react'


const useInput = ({required = false, initialValue = '', valueType = 'value', onInvalid}) => {
    const ref = useRef()

    const [value, setValue] = useState(initialValue)
    const [error, setError] = useState(null)

    const [disabled, setDisabled] = useState(false)
    const [displayError, setDisplayError] = useState(false)

    const [touched, setTouched] = useState(false)

    /** Validate on event */
    const validate = (e) => {
        const isValid = e.target.checkValidity()
        if (isValid && error){
            setError(null)
        } else if (!isValid) {
            setError(e.target.validationMessage)
        }
    }

    /** Reset value from outside */
    const reset = () => {
        setValue(initialValue)
        setError(null)
        setDisplayError(false)
    }

    /** Handle update to input with error displaley at delay */
    const onChange = (e) => {
        setDisplayError(false)
        setTouched(true)

        let value = e.target[valueType]

        setValue(value)
        validate(e)
        if (valueType === 'checked'){
            setDisplayError(true)
        } else {
 
            setTimeout(() => {
                if (value === e.target[valueType]){
                    setDisplayError(true)
                }
            }, 2000); 
        }  
    }

    /** Displays error on */
    const onBlur = () => {
        if (!displayError){
            setDisplayError(true)
        }
    }



    useImperativeHandle(ref, () => ({
        reset() {
            reset()
        },
        lock() {
            setDisabled(true)
        },
        unlock () {
            setDisabled(false)
        },
        value() {
            return (value)
        },
        isValid() {
            setDisplayError(true)
            if(required && (!value || value === '')){
                setError("errorRequiredField")
                return false
            }
            return error ? false : true
        },
        getError(){
            return error
        }
    }))



    return {
        ref,
        value,
        reset,
        error,
        disabled,
        displayError,
        bind: {
            [valueType]: value,
            onChange,
            onBlur
        }
    }
}

export default useInput;